// Marketing attribution: capture UTM/click IDs on landing, attach to orders at checkout.
const KEY = 'dyssc_attribution';
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];

export function captureAttribution() {
  try {
    const url = new URL(window.location.href);
    const touch = {};
    PARAMS.forEach((p) => {
      const v = url.searchParams.get(p);
      if (v) touch[p] = v.slice(0, 200);
    });
    if (touch.fbclid && !touch.utm_source) touch.utm_source = 'facebook';
    if (touch.gclid && !touch.utm_source) touch.utm_source = 'google';
    if (Object.keys(touch).length === 0) return;
    touch.landing = (url.pathname || '/').slice(0, 200);
    touch.ts = new Date().toISOString();
    if (document.referrer) touch.referrer = document.referrer.slice(0, 200);
    const existing = JSON.parse(localStorage.getItem(KEY) || 'null') || {};
    localStorage.setItem(KEY, JSON.stringify({ first: existing.first || touch, last: touch }));
  } catch { /* attribution is best-effort */ }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null');
  } catch { return null; }
}
